import React from "react";
import PropTypes from "prop-types";
import USBButtonGroup from "@usb-shield/react-button-group";
import USBButton from "@usb-shield/react-button";
import { USBIconWarning } from "@usb-shield/react-icons/dist/esm";
import { BlockLayout } from "../index";
// import useScreenHeight from "../utils/useScreenHeight";

export const PageFooterWrapper = ({
  buttonOptions,
  showRemoveButtonAloneInMobile,
  isOLBOrIpadApp,
  children,
  contentBelowButton,
  otherBlockProps,
  shouldAdjustTuxHeight,
  contentAbovePrimaryButton,
  hideFloatingFooterContent,
  isCardLastChild,
}) => {
  if (!Array.isArray(buttonOptions)) {
    return (
      <BlockLayout
        actAs={isCardLastChild ? "CardLastChildFooter" : "PageFooter"}
        removeSpaceOf={["padding", "margin"]}
      >
        {" "}
        <div className="usbobp-c-footer footer--error">
          <USBIconWarning title="button warning" colorVariant="error" />
          Please add a valid button array to the buttonOptions prop.
        </div>
      </BlockLayout>
    );
  }

  if (buttonOptions.length >= 4 || buttonOptions.length === 0) {
    return (
      <BlockLayout
        actAs={isCardLastChild ? "CardLastChildFooter" : "PageFooter"}
        removeSpaceOf={["padding", "margin"]}
      >
        <div className="usbobp-c-footer footer--error">
          <USBIconWarning title="button warning" colorVariant="error" />
          The buttonOptions prop requires at least 1 button and no more than 3.
        </div>
      </BlockLayout>
    );
  }

  if (!isOLBOrIpadApp()) {
    const redButton = buttonOptions.find((button) => button?.isDangerousAction);

    return (
      <div
        style={{ display: "flex", flexDirection: "column",
        height: shouldAdjustTuxHeight ? "calc(100vh - 56px)" : "100vh", 
        justifyContent: 'space-between',
        // height: firstHeight ? 'auto' : '100vh' 
      }}
      >
        <section style={{ overflowY: "auto" }}>
          {children && children}
          {redButton && showRemoveButtonAloneInMobile && (
            <BlockLayout
              actAs="CardChild"
              gapOnTop="16"
              mobileBottomMargin="10"
              mobileTopMargin="10"
            >
              <USBButton
                id={redButton?.id}
                variant={redButton?.type}
                handleClick={redButton?.clickEvent}
                addClasses="usbobp-c-footer__removeButtonAlone"
                spacing={{ margin: 0 }}
              >
                <span className="usb-tg-body-medium">{redButton?.text}</span>
              </USBButton>
            </BlockLayout>
          )}
          {contentBelowButton && contentBelowButton}
        </section>
        {!hideFloatingFooterContent && (
          <BlockLayout
            actAs={isCardLastChild ? "CardLastChildFooter" : "PageFooter"}
            removeSpaceOf={["padding", "margin"]}
          >
            <PageFooterComponent
              {...{
                buttonOptions,
                showRemoveButtonAloneInMobile,
                isOLBOrIpadApp,
                contentAbovePrimaryButton,
              }}
            />
          </BlockLayout>
        )}
      </div>
    );
  }

  return (
    <>
      {children && children}
      {contentBelowButton && contentBelowButton}
      {!hideFloatingFooterContent && (
        <BlockLayout
          actAs={isCardLastChild ? "CardLastChildFooter" : "PageFooter"}
          removeSpaceOf={["padding", "margin"]}
          {...otherBlockProps}
        >
          <PageFooterComponent
            {...{
              buttonOptions,
              showRemoveButtonAloneInMobile,
              isOLBOrIpadApp,
              contentAbovePrimaryButton,
            }}
          />
        </BlockLayout>
      )}
    </>
  );
};

export const PageFooterComponent = ({
  isOLBOrIpadApp,
  buttonOptions,
  showRemoveButtonAloneInMobile,
  contentAbovePrimaryButton,
}) => {
  if (!isOLBOrIpadApp()) {
    const redButton = buttonOptions.find((button) => button?.isDangerousAction);
    return (
      <div className="usbobp-c-footer hide-footer">
        <USBButtonGroup>
          {contentAbovePrimaryButton && contentAbovePrimaryButton}
          {(redButton && !showRemoveButtonAloneInMobile
            ? buttonOptions
            : buttonOptions.filter((button) => !button?.isDangerousAction)
          ).map(
            (
              {
                id,
                type,
                clickEvent,
                text,
                show = true,
                isDangerousAction = false,
              },
              index
            ) => {
              if (show) {
                return (
                  <USBButton
                    key={index}
                    id={id}
                    variant={type}
                    handleClick={clickEvent}
                    addClasses={isDangerousAction && "red-button-style"}
                  >
                    {text}
                  </USBButton>
                );
              }
            }
          )}
        </USBButtonGroup>
      </div>
    );
  } else {
    return (
      <div className="usbobp-c-footer hide-footer">
        <USBButtonGroup>
          {contentAbovePrimaryButton && contentAbovePrimaryButton}
          {buttonOptions.map(
            (
              {
                id,
                type,
                clickEvent,
                text,
                show = true,
                isDangerousAction = false,
              },
              index
            ) => {
              if (show) {
                return (
                  <USBButton
                    key={index}
                    id={id}
                    variant={type}
                    handleClick={clickEvent}
                    addClasses={isDangerousAction && "red-button-style"}
                  >
                    {text}
                  </USBButton>
                );
              }
            }
          )}
        </USBButtonGroup>
      </div>
    );
  }
};

PageFooterWrapper.propTypes = {
  buttonOptions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      clickEvent: PropTypes.func.isRequired,
      show: PropTypes.bool,
      id: PropTypes.string,
    }).isRequired
  ),
  children: PropTypes.node,
  showRemoveButtonAloneInMobile: PropTypes.bool,
  isOLBOrIpadApp: PropTypes.func.isRequired,
  contentBelowButton: PropTypes.node,
  otherBlockProps: PropTypes.object,
  shouldAdjustTuxHeight: PropTypes.bool,
  hideFloatingFooterContent: PropTypes.bool,
  contentAbovePrimaryButton: PropTypes.node,
  isCardLastChild: PropTypes.bool,
};
PageFooterWrapper.defaultProps = {
  showRemoveButtonAloneInMobile: false,
  contentBelowButton: <div />,
  children: <div />,
  otherBlockProps: {},
  shouldAdjustTuxHeight: false,
  hideFloatingFooterContent: false,
  contentAbovePrimaryButton: <></>,
  isOLBOrIpadApp: () => false,
  isCardLastChild: false,
};

export default PageFooterWrapper;
